import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from 'react-i18next';

const OutsourcingCost5 = props => (
    <section id="outsourcing-cost-section5" className="my pt-5 black-bg">
        {/* <div className='white-shape'></div> */}
        <Container>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5 blue">{props.t('services:outsourcingCost:section-5.title')}</h2>
            <p className='mb-5'>{props.t('services:outsourcingCost:section-5.txt')}</p>
            {/* Sub-item 1 */}
            <div className='mb-5'>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingCost:section-5.1.title')}</h3>
                </div>
                <p>{props.t('services:outsourcingCost:section-5.1.text')}</p>
            </div>
            {/* Sub-item 2 */}
            <div className='mb-5'>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingCost:section-5.2.title')}</h3>
                </div>
                <p>{props.t('services:outsourcingCost:section-5.2.text')}</p>
            </div>
            {/* Sub-item 3 */}
            <div className='mb-5'>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingCost:section-5.3.title')}</h3>
                </div>
                <p><Trans i18nKey="services:outsourcingCost:section-5.3.text"
                    components={{
                        br: <br />,
                        outsourcingAdvantages: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing_advantages.path')} className="link" />
                    }}
                /></p>
            </div>
            {/* Sub-item 4 */}
            <div>
                <div className='d-flex align-items-center mb-4'>
                    <div className='arrow-container'>
                        <div className='arrow'>
                            <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                        </div>
                    </div>
                    <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingCost:section-5.4.title')}</h3>
                </div>
                <p className='m-0'>{props.t('services:outsourcingCost:section-5.4.text')}</p>
            </div>
        </Container>
    </section>
);

export default OutsourcingCost5;
